import "./Loading.css";
function Loading() {
  return (
    <>
      <h1>Loading</h1>
      {/* <div className="container">
        <div>
          <span className="one h6"></span>
          <span className="two h3"></span>
        </div>
      </div>

      <div>
        <div>
          <span className="one h1"></span>
          <span className="two h4"></span>
        </div>
      </div>

      <div>
        <div>
          <span className="one h5"></span>
          <span className="two h2"></span>
        </div>
      </div> */}
    </>
  );
}

export default Loading;
